import { Box, Heading, VStack } from '@chakra-ui/react';
import type React from 'react';

interface LockedStepProps {
  /** Position in the sequence; the two steps have to be done in order. */
  index: number;
  title: string;
  children: React.ReactNode;
}

/** One of the two moves that reopen the dashboard. */
export const LockedStep: React.FC<LockedStepProps> = ({ index, title, children }) => (
  <Box
    w="full"
    borderWidth="1px"
    borderColor="#d8d2c6"
    borderRadius="lg"
    bg="white"
    px={{ base: 4, md: 6 }}
    py={{ base: 4, md: 5 }}
  >
    <VStack align="flex-start" gap={3}>
      <Heading as="h2" fontSize="15px" fontWeight="600" color="dark">
        {index}. {title}
      </Heading>
      {children}
    </VStack>
  </Box>
);
